import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import Icon from "../icon/Icon";

function StepBar(props) {

    const [stepBar, setStepBar] = useState([])
    const history = useHistory()

    useEffect(() => {
        createStepBar()
    },[props.steps,props.stepAttivo])

    function onClickStep(codiceStep){
        history.push({
            pathname: props.path ? props.path : "#",
            steps:history.location.steps?history.location.steps:[],
            stepAttivo:codiceStep
        })
    }

    function createStepBar(){
        let newStepBar = []
        if(props.steps.length > 0){
            props.steps.forEach(step => {
                let newStep = (
                    <div key={step.codiceStep} className={props.col} style={{borderBottom:step.codiceStep === props.stepAttivo ? "3px solid #1b7ea9" : "3px solid black", alignItems: "center", display: "flex", justifyContent: "center",opacity:step.codiceStep === props.stepAttivo?"1":"0.5"}}>
                        { step.iconAttivo || step.iconDisattivato ? <Icon height={"50px"} width={"50px"} path={step.codiceStep === props.stepAttivo ? step.iconAttivo : step.iconDisattivato} style={{marginRight: "10px", cursor: "pointer"}} onClick={step.cliccabile ? () => onClickStep(step.codiceStep):null}></Icon> : null }
                        <span style={{color: step.codiceStep === props.stepAttivo && (step.iconAttivo || step.iconDisattivato) ? "#1b7ea9" : "black", fontWeight:"bold",fontSize:"24px",cursor:step.cliccabile?"pointer":"default"}} onClick={step.cliccabile ? () => onClickStep(step.codiceStep):null}>{step.nome}</span>
                    </div>
                )
                newStepBar.push(newStep)
            })
            setStepBar(newStepBar)
        }
    }

    return (
        <div className={"row"} style={{height:"70px"}}>
            {stepBar}
        </div>
    )
}

export default StepBar
